import { Component, useEffect, useRef, useState } from "react";
import { Dimensions, FlatList, LogBox, NativeScrollEvent, NativeSyntheticEvent, Pressable, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native"
import { Checkbox, IconButton, TextInput as PaperTextInput, Provider as PaperProvider, Portal, Modal, TextInput } from "react-native-paper";
import { DEBUG, enablePromise, openDatabase } from "react-native-sqlite-storage";
import { stopCodes } from "../StockAwareTempData";
import { MyButton } from "../buttonsAndControls";

const darkColour='#2a2d3e';

interface Data {
  id: number;
  texts: string[];
}

interface VendorsList {
  ID: number;
  Vendor: string;
}

interface ItemsList {
  ID: number;
  Item_Name: string;
  Item_Quantity: number;
  Patronage: number;
  Price: number
}

interface StockList {
  ID: number;
  Quantity: number;
  Item_Name: string;
  Vendor: string;
  Last_Updated: string;
  Amount_Paid: number;
  Notes: string
  Item_Price: number;
}

interface CustomerRecord {
  ID: number;
  Quantity: number
  Customer_Name: string;
  Phone_Number: string;
  Date: string;
  Patronage: number;
  After_Discount: number;
}

const CustomerView = ({texts, isChecked, onCheckboxChange, index,
}: Data & { isChecked: boolean; onCheckboxChange: (value: boolean) => void; index: number; }) => {
  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const sizes: number[] = [303, 150, 150, 150, 150, 150];
  return (
    <View style={{ backgroundColor }}>
      <TouchableOpacity style={{...styles.childTouchable, backgroundColor: isChecked ? darkColour : 'transparent'}}
      	onPress={() => onCheckboxChange(!isChecked)}>
				{texts.map((text, i) => (
					<View key={i} style={{...styles.childBoxes, width: sizes[i]}}>
						<Text key={i} style={{...styles.childText,  color: isChecked ? 'white' : darkColour}}>
							{text}
						</Text>
					</View>
				))}
      </TouchableOpacity>
    </View>
  );
};

export const Vendors = ({ texts, id, compareClicked, isChecked, onCheckboxChange, index, onPressed, displayingVL}
  : Data & { compareClicked: number, isChecked: boolean; onCheckboxChange: (value: boolean) => void; 
    index: number;  onPressed: () => void; displayingVL: boolean}) => {

    const isEvenIndex = index % 2 === 0;
    const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
    const [hovered, setHovered] = useState(false);
    const [isOpacity, setIsOpacity] = useState(false);
    const wdth = hovered ? 264 : 300
    const sizes: number[] = [wdth, 100, 100, 152];
    return (
      <View style={{ backgroundColor }}>
        <TouchableOpacity style = {{ backgroundColor: isChecked ? darkColour : 'transparent'}}>
          <Pressable style={{...styles.vendorTouchable,  
            backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
            opacity: isOpacity ? 0.2 : 1 }}
            onHoverIn={() => setHovered(true)}
            onHoverOut={() => setHovered(false)}
            onPressIn={() => setIsOpacity(true)}
            onPressOut={() => setIsOpacity(false)}
            onPress={() => {onPressed();}}
            >
               {hovered && (
              <Checkbox
                status={isChecked ? 'checked' : 'unchecked'}
                onPress={() => onCheckboxChange(!isChecked)}
                color = {darkColour}
              />
            )}
            {texts.map((text, i) => (
              
              <View key={i} style={{...styles.viewStyle, width: sizes[i], borderRightWidth: displayingVL ? 0 : 2 }} >
                <Text key={i} style={{...styles.textStyle, flex: displayingVL ? 1 : 0, 
                  color: isChecked ? hovered ? darkColour : 'white' : darkColour}}>
                  {text}
                </Text>
                
              </View>
            ))}
            {(hovered || (id === compareClicked)) &&  displayingVL &&
              <IconButton icon={'play'} size={15} focusable={false} iconColor={darkColour} style={styles.iconButtonStyle} />
            }
          </Pressable>
        </TouchableOpacity>
  
      </View>
  )
}

const VendorSub = ({ texts, index, onPressed } : Data & { index: number;  onPressed: () => void; }) => {
    const isEvenIndex = index % 2 === 0;
    const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
    const [hovered, setHovered] = useState(false);
    const [isOpacity, setIsOpacity] = useState(false);
    const wdth = hovered ? 264 : 300
    const sizes: number[] = [57, 200, 430, 120, 167];
    return (
      <View style={{ backgroundColor }}>
        <TouchableOpacity style = {{ backgroundColor: 'transparent'}}>
          <Pressable style={{...styles.vendorTouchable,  
            backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
            opacity: isOpacity ? 0.2 : 1 }}
            onHoverIn={() => setHovered(true)}
            onHoverOut={() => setHovered(false)}
            onPressIn={() => setIsOpacity(true)}
            onPressOut={() => setIsOpacity(false)}
            >
            {texts.map((text, i) => (
              
              <View key={i} style={{...styles.viewStyle, width: sizes[i], borderRightWidth: 2 }} >
                <Text key={i} style={{...styles.textStyle, color: darkColour}}>
                  {text}
                </Text>
                
              </View>
            ))}
  
            {hovered &&
              <IconButton icon={'trash-can-outline'} size={25} focusable={false} iconColor={darkColour} style={styles.iconButtonStyle} 
              onPress={() => {onPressed();}}
              />
            }
           
          </Pressable>
        </TouchableOpacity>
  
      </View>
  )
}

export const VendorView = () => {
  const [filteredResult, setFilteredResult] = useState<VendorsList[]>([]);
  const [ven, setVen] = useState<VendorsList[]>([]);
  const [filteredResultStock, setFilteredResultStock] = useState<StockList[]>([]);
  const [stock, setStock] = useState<StockList[]>([]);
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [searchText, setSearchText] = useState('');
  const [markedID, setMarkedID] = useState<boolean[]>([]);
	const [deleteArrayID, setDeleteArrayID] = useState<string[]>([]);
  const [showCond, setShowCond] = useState(-1);
  const [itemsList, setItemsList] = useState<ItemsList[]>([]);
  const [filItemsList, setFilItemsList] = useState<ItemsList[]>([]);
  const [scrollIndex, setScrollIndex] = useState(0);
  const [appearPosition, setAppearPosition] = useState(0);
  const [compareData, setCompareData] = useState(-1);
  const [showModal, setShowModal] = useState(false);
  const [grossTotal, setGrossTotal] = useState('');
  const [vendor, setVendor] = useState('')
  const [holdTotal, setHoldTotal] = useState(' ');
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
  let timeout: NodeJS.Timeout
  const rowCount = 2
  const [count, setCount] = useState(rowCount);
  const [maxCount, setMaxCount] = useState(0)
  const [initial, setInitial] = useState(0);
  const [itName, setItName] = useState('')
  const [nextDisabled, setNextDisabled] = useState(false)
  const [prevDisabled, setPrevDisabled] = useState(false)
  const [customerList, setCustomerList] = useState<CustomerRecord[]>([]);
  const rowsPerPage = 50;
  const [startIndex, setStartIndex] = useState(0);
  const displayedData = customerList.slice(startIndex, startIndex + rowsPerPage);
  const flatListRef = useRef<FlatList>(null);
  const [patronage, setPatronage] = useState('');
  const [quantity, setQuantity] = useState('');
  const [amount, setAmount] = useState('');

  const fetchData = async () => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
			tx.executeSql(
        `SELECT ID, Vendor FROM Purchase_Record GROUP BY Vendor ORDER BY ID;`,
        [],
        (_, results) => {
          const rows = results.rows;
          const vendorsArray: VendorsList[] = [];
          for (let i = 0; i < rows.length; i++) {
            if (!vendorsArray.includes(rows.item(i).Vendor)) {
              vendorsArray.push(rows.item(i) as VendorsList);
              console.log(rows.item(i))
            }
          }
          setVen(vendorsArray)
					setFilteredResult(vendorsArray);

          const updatedCheckedItems: boolean[] = Array.from(
						{ length: vendorsArray.length },
						() => false
					);
					setCheckedItems(updatedCheckedItems)

        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );

      tx.executeSql(
        `SELECT sr.ID, sr.Customer_Name, sr.Phone_Number, MAX(sr.Date) AS Date,
        (SELECT SUM(sr2.After_Discount) FROM Sales_Record sr2 
        WHERE sr2.Customer_Name = sr.Customer_Name 
        AND sr2.Phone_Number = sr.Phone_Number) AS After_Discount, 
        COUNT(sr.Customer_Name) AS Patronage, SUM(si.Quantity) AS Quantity 
        FROM Sales_Record sr JOIN Sales_Items si ON sr.ID = si.Sales_ID
        GROUP BY sr.Customer_Name, sr.Phone_Number 
        ORDER BY Patronage DESC, After_Discount DESC;			
    `,        [],
        (_, results) => {
          const rows = results.rows;
          const customerArray: CustomerRecord[] = [];
          for (let i = 0; i < rows.length; i++) {
            if (!customerArray.includes(rows.item(i).Vendor)) {
              customerArray.push(rows.item(i) as CustomerRecord);
            }
          }
					setCustomerList(customerArray);
        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }

  const fetchItems = async (vendorName: string) => {
		DEBUG(true);
		enablePromise(true);
		const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
    (await initDB).transaction((tx) => {
     tx.executeSql(` SELECT ID, Item_Name, COUNT(*) AS Patronage, SUM(Quantity) AS 
      Item_Quantity, SUM(Item_Price) AS Price FROM Purchase_Record WHERE Vendor = ? GROUP BY Item_Name;`,
      [vendorName],
        (_, results) => {
          const rows = results.rows;
          const itemsArray: ItemsList[] = [];
          for (let i = 0; i < rows.length; i++) {
            itemsArray.push(rows.item(i) as ItemsList);
          }
          setItemsList(itemsArray)
					setFilItemsList(itemsArray);

        },
        (error) => {
          console.error('Error executing SQL', error);
        }
      );
    })
  }
  
  const fetchSubItems = async (Vendor: string, Item: string) => {
    try {
      if (Vendor && Item) {
        DEBUG(true);
        enablePromise(true);
        const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
        (await initDB).transaction((tx) => {
        tx.executeSql(` SELECT * FROM Purchase_Record WHERE Vendor = ? AND Item_Name = ? ORDER BY Last_Updated;`,
          [Vendor, Item],
            async (_, results) => {
              const rows = results.rows;
              let amt = 0
              const itemsSubArray: StockList[] = [];
              setMaxCount(rows.length) 
              count >= maxCount ? (setNextDisabled(true)) : setNextDisabled(false)
              initial < rowCount ? (setPrevDisabled(true)) : setPrevDisabled(false)
              for (let i = initial; i < (count > rows.length ? rows.length : count); i++) {
                itemsSubArray.push(rows.item(i) as StockList);
                amt = amt + ((rows.item(i).Amount_Paid || 0 ) * (rows.item(i).Quantity || 0))
              }
              setFilteredResultStock(itemsSubArray)
              setGrossTotal(amt.toString())
              
            },
            (error) => {
              console.error('Error executing SQL', error);
            }
          );
        })
      }
    } catch (error) {
      console.log(error)
    }
    
  }

  useEffect(() => {
    if (stopCodes) {
      fetchSubItems(vendor, itName)
    }
  }, [stopCodes, maxCount, count])

  useEffect(() => {
    if (stopCodes) {
      let pt = 0;
      let qty = 0;
      let amt = 0;
      for (const row of filItemsList) {
        pt += row.Patronage
        qty += row.Item_Quantity
        amt += row.Price
      }
      setPatronage(pt.toString());
      setQuantity(qty.toString());
      setAmount(amt.toString());

      console.log(pt, qty, amt)
    }
  }, [stopCodes, filItemsList])

  useEffect(() => {
		if (stopCodes) {
    	try {
      	fetchData();	
      } catch (error) {
        console.log(error)
      
      }
		}
    }, [stopCodes]);

    useEffect(() => {
      if (stopCodes) {
        setAppearPosition((-649) + ((showCond - scrollIndex) * 33))
      }
      }, [stopCodes, scrollIndex, showCond]);

      useEffect(() => {
        if (stopCodes) {
          const filterChildViews = async () => {
            const filteredViews = await filterViews() as VendorsList[];
            setFilteredResult(filteredViews);
          };

        filterChildViews();
        }
      }, [ven, checkedItems, searchText, stopCodes]);

    const handleSearchTextChange = (value: string) => {
      setSearchText(value);
    };

    const filterViews = async () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const filteredViews = ven.filter((child) => {
            const hasTextMatch = ((child.Vendor?.toLowerCase() ) )?.includes(searchText.toLowerCase())
            const hasIdMatch = child.ID?.toString().includes(searchText.toLowerCase());
            return hasTextMatch || hasIdMatch;
          });
  
          resolve(filteredViews);
        }, 0);
      });
    };

    const deleteCheckedItems = () => {
      const updatedCheckedItems = checkedItems.filter((_, index) => !checkedItems[index]);
      const updatedChildViews = ven.filter((_, index) => !markedID[index]);
    
      setCheckedItems(updatedCheckedItems);
      setVen(updatedChildViews);
      setMarkedID([]);
  
      markedForDelete();
    };

    const markedForDelete = async () => {
      DEBUG(true);
      enablePromise(true);
      const initDB =  openDatabase({name: 'StockAware.db', location:'default'});
      (await initDB).transaction((tx) => {
        deleteArrayID.forEach((row) => {
          tx.executeSql(
            `DELETE FROM Purchase_Record WHERE Vendor = ?;`,
            [row],
            (_, results) => {
              if (results.rowsAffected > 0) {
                console.log('Deleted Successfully')
              }
            },
            (error) => {
              console.error('Error executing SQL', error);
            }
          );
        })
      })
      setDeleteArrayID([])
      setShowCond(-1)
      setCompareData(-1)
    }

    const findIndexById = (array: any[], id: number | string): number => {
			return array.findIndex((item) => item.ID === id);
		};

    const handleCheckboxChange = (index: number, value: boolean, id: string, idNum:number) => {
			const updatedCheckedItems = [...checkedItems];
			updatedCheckedItems[index] = value;
			setCheckedItems(updatedCheckedItems);
	
			const idIndex = findIndexById(ven, idNum);
			const updatedMarkedID = [...markedID];
			updatedMarkedID[idIndex] = value;
			
			setMarkedID(updatedMarkedID);
			if (deleteArrayID.includes(id)) {
        setDeleteArrayID((prevDel) => prevDel.filter((value) => value !== id));
      } else {
      setDeleteArrayID((prevDel) => [...prevDel, id]);
      };
		};

    // const handleCheckbox = (index: number, value: boolean, id: number) => {
		// 	const updatedCheckedItems = [...checkedItems];
		// 	updatedCheckedItems[index] = value;
		// 	setCheckedItems(updatedCheckedItems);
	
		// 	const idIndex = findIndexById(ven, id);
		// 	const updatedMarkedID = [...markedID];
		// 	updatedMarkedID[idIndex] = value;
			
		// 	setMarkedID(updatedMarkedID);
		// 	if (deleteArrayID.includes(id)) {
    //     setDeleteArrayID((prevDel) => prevDel.filter((value) => value !== id));
    //   } else {
    //   setDeleteArrayID((prevDel) => [...prevDel, id]);
    //   };
		// };

    const handleScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      // Calculate the current scroll index based on the scroll position and item height
      const contentOffsetY = event.nativeEvent.contentOffset.y;
      const index = Math.floor(contentOffsetY / 33);
      setScrollIndex(index);
    };
  
    const handleClick = async () => {
      setInitial((prev) => prev + rowCount);
      setCount((prev) => prev + rowCount);
      const updatedInitial = initial + rowCount;
      const updatedCount = count + rowCount;
      fetchSubItems(vendor, itName);
    };

    const handlePrevClick = async () => {
      setInitial((prev) => prev - rowCount);
      setCount((prev) => prev - rowCount);
      const updatedInitial = initial - rowCount;
      const updatedCount = count - rowCount;
      fetchSubItems(vendor, itName);
      
    };

    const handleNext = async () => {
      setStartIndex((prevIndex) => prevIndex + rowsPerPage);
      flatListRef.current?.scrollToOffset({ offset: 0, animated: true });
    };

    const handlePrevious = async () => {
      setStartIndex((prevIndex) => prevIndex - rowsPerPage);
      flatListRef.current?.scrollToOffset({ offset: 0, animated: true });      
    };

    const handleModalDismissed = () => {
      setShowModal((prev) => !prev);
      setCount(rowCount);
      setMaxCount(0);
      setInitial(0);
      setItName('');
      setFilteredResultStock([]);
    }

    const handleSavePDF = async () => {
      // createAndSavePDF()
      //   .then(result => {
      //     if (result) {
      //     console.log(result)
      //     } else {
      //       console.log('PDF creation failed.');
      //     }
      //   })
      //   .catch(error => {
      //     console.error('An error occurred:', error);
      //   });
    };
  return (
    <PaperProvider>
      <View style = {{ flexDirection: 'column'}}>
          <View style = {{flexDirection:'row'}}>
            <View style = {styles.vendorParentContainer}>
              <Text style = {{...styles.tabHeadText, marginTop:20 }}>
                Vendor List
              </Text>
              <View style={{flexDirection:'row', alignItems:'center'}}>
                <View style={{width:200, marginRight:10}}>
                  <PaperTextInput
                    mode="outlined"
                    label={'Search vendors'}
                    placeholder="Search"
                    underlineColor={darkColour}
                    activeOutlineColor={darkColour}
                    spellCheck={false}
                    contentStyle={{
                      paddingTop: 7, 
                      borderWidth:1, 
                      width: 200, 
                      height:40, 
                      borderRadius:10, 
                      borderColor: '#DCE3E8'
                    }} 
                    outlineStyle={{ borderWidth: 0, height:40 }}
                    onChangeText={handleSearchTextChange}
                  />
                </View>
                {deleteArrayID.length > 0 &&
                <View>
                  <MyButton btnText="Delete" btnWidth = {100} hndClicked={deleteCheckedItems} />
                </View>}
              </View>
              <View style = {styles.vendorContainer}>
                <ScrollView onScroll={handleScroll}>
                  {filteredResult.map((vendor, index) => (
                    <Vendors
                      key={vendor.ID}
                      texts={[ vendor.Vendor ]}
                      index={index}
                      id={vendor.ID}
                      compareClicked={compareData}
                      onCheckboxChange={(value) => handleCheckboxChange(index, value, vendor.Vendor, vendor.ID)}
                      isChecked={deleteArrayID.includes(vendor.Vendor) ? true : false}
                      displayingVL = {true}
                      onPressed={()=>{showCond === index ? (setShowCond(-1), setCompareData(-1), setVendor('')) 
                        : (setShowCond(index), setCompareData(vendor.ID), fetchItems(vendor.Vendor), setVendor(vendor.Vendor)); }}
                    />
                  ))}
                </ScrollView>
              </View>
            </View>
            <View>
            <View style = {{...styles.secondBox, width: 1040, height: 50, flexDirection: 'row' }}>
              <View style = {{marginLeft: 10, alignSelf: 'center'}}>
                <Text style={styles.tabHeadText}>Customers Tab</Text>
              </View>
              <View style={styles.deleteContainer}>
                  <View style={{marginHorizontal:10, width:80}}>
                    {startIndex > 0 &&
                      <MyButton btnText="Previous"
                        btnBorClr={darkColour}
                        btnBorRadius={10}
                        btnBorWdt={2}
                        disabled = {prevDisabled}
                        btnFontSize={15}
                        btnHeight={32}
                        btnWidth={75}
                        btnPadding={4}
                        hndClicked={handlePrevious}
                      />
                    }
                  </View>
                  <View style={{marginHorizontal:10, width:80}}>
                    {customerList.length > startIndex + 50 &&
                      <MyButton btnText="Next"
                        btnBorClr={darkColour}
                        btnBorRadius={10}
                        btnBorWdt={2}
                        disabled = {nextDisabled}
                        btnFontSize={15}
                        btnHeight={32}
                        btnWidth={75}
                        btnPadding={4}
                        hndClicked={handleNext}
                      /> 
                    }
                  </View>
                
                </View>
            </View>
              <View style={styles.secondBoxHeader}>
                <View style={{ ...styles.columnHeaderBox, width: 301, marginLeft: 0, borderLeftWidth: 0 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Name</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150}}>
                  <Text style={{ ...styles.columnHeaderText }}>Phone Number</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Last Purchase</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Patronage Count</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 150 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Total Quantity</Text>
                </View>
                <View style={{ ...styles.columnHeaderBox, width: 148, borderRightWidth: 0 }}>
                  <Text style={{ ...styles.columnHeaderText }}>Total Amount (₦)</Text>
                </View>
              </View>
              <View style = {{  width: 1040, height: 619, marginHorizontal: 10, backgroundColor:'white',}}>
              <FlatList
                  ref={flatListRef}
									data={displayedData}
									keyExtractor={(item) => item.ID.toString()}
									renderItem={({ item, index }) => (
										<CustomerView
											key={item.ID}
											texts={[
												item.Customer_Name?.toString(),
												item.Phone_Number?.toString(),
												item.Date?.toString(),
												item.Patronage?.toString(),
												item.Quantity?.toString(),
												Number(item.After_Discount)?.toLocaleString('en-NG'),
											]}
											isChecked={deleteArrayID.includes(item.ID.toString()) ? true : false}
											onCheckboxChange={(value) => {}}
											index={index}
											id={item.ID}
										/>
									)}
								/>
              </View>
              <View style = {{...styles.boxFooterText, marginHorizontal: 10, width: 1040 }}>
                {/* <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center', width: 471 }}>
                 
                </Text>
                <IconButton
                      icon="ray-start-arrow"
                      iconColor= 'white'
                      size={40}
                      focusable={false}
                      style={{marginRight:90, marginLeft: -20, marginTop:-8}}
                    />
                <View style = {styles.boxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  </Text>
                </View>
                <View style = { styles.boxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  </Text>
                </View>
                <View style = { styles.boxFooterTotal}>
                  <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                  </Text>
                </View> */}
              </View>
            </View>
          </View>
          {showCond !== -1 &&
            <View style = {{...styles.vendorContainer, width: 646, borderRadius: 10, borderTopLeftRadius:0, 
              marginTop: ( (appearPosition < -649) ? -649 : (appearPosition > -351) ? -351 : appearPosition ), marginLeft:338}}>
              <View style={{width: '100%', height:33, backgroundColor: darkColour, flexDirection:'row', borderTopRightRadius:10}}>
                <View style={{...styles.columnHeaderBox, width:300, flexDirection: 'row', justifyContent: 'space-evenly'}}>
                  <Text style={{...styles.columnHeaderText, marginTop: 0}}>
                    Board Description
                  </Text>
                  <View style={{...styles.textInputMasterContainer, width: 100, height: 25, marginTop:-15}}> 
                    <TextInput
                      mode="outlined"
                      placeholder="Search..."
                      underlineColor={darkColour}
                      activeOutlineColor={darkColour}
                      spellCheck={false}
                      contentStyle={{...styles.searchTextInput, width: 100}} 
                      style={{marginTop:-1, height:30 }}
                      outlineStyle={{ borderWidth: 0, height:30, borderRightColor:'white', }}
                      onChangeText={handleSearchTextChange}
                    />
                  </View>
                </View>
                <View style={{...styles.columnHeaderBox, width:100}}>
                  <Text style={{...styles.columnHeaderText}}>
                    P.C
                  </Text>
                </View>
                <View style={{...styles.columnHeaderBox, width:100}}>
                  <Text style={{...styles.columnHeaderText}}>
                    Total Q.
                  </Text>
                </View>
                <View style={{...styles.columnHeaderBox, width:150}}>
                  <Text style={{...styles.columnHeaderText}}>
                    Total Amount (₦)
                  </Text>
                </View>
              </View>
              <ScrollView>
                {filItemsList.map((items, index) => (
                  <Vendors
                    key={items.ID}
                    texts={[ items.Item_Name, 
                      Number(items.Patronage).toLocaleString('en-NG'), 
                      Number(items.Item_Quantity).toLocaleString('en-NG'),
                      Number(items.Price).toLocaleString('en-NG') ]}
                    index={index}
                    id={items.ID}
                    compareClicked={-1}
                    onCheckboxChange={()=>{}}
                    isChecked={false}
                    displayingVL = {false}
                    onPressed={()=>{fetchSubItems(vendor, items.Item_Name), setShowModal(true), setItName(items.Item_Name)}}
                  />
                ))}
              </ScrollView>
              <View style = {styles.boxFooterText}>
                <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center', width: 250 }}>
                  Accumulated Total
                </Text>
                <IconButton
                    icon="ray-start-arrow"
                    iconColor= 'white'
                    size={40}
                    focusable={false}
                    style={{marginRight:12, marginLeft: -20, marginTop:-8}}
                  />

                  <View style = {{...styles.boxFooterTotal, width: 100}}>
                    <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                      {Number(patronage).toLocaleString('en-NG')}
                    </Text>
                  </View>
                  <View style = {{...styles.boxFooterTotal, width: 100}}>
                    <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                      {Number(quantity).toLocaleString('en-NG')}
                    </Text>
                  </View>
                  <View style = {{...styles.boxFooterTotal, width: 150}}>
                    <Text style={{ ...styles.columnHeaderText, marginTop: 0, alignSelf: 'center'}}>
                      {Number(amount).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                    </Text>
                  </View>
                
              </View>
            </View>
          }
          
        <Portal>
          <Modal visible={showModal} onDismiss={handleModalDismissed} dismissable={true} contentContainerStyle={styles.modalContainer}>
            <View style={{width:1040, height:500}}>
              <View style={styles.mainView}>
                <View style={styles.headerContainer}>
                  <View style={styles.textInputMasterContainer}> 
                    <TextInput
                      mode="outlined"
                      label={'Search record'}
                      placeholder="Search"
                      underlineColor={darkColour}
                      activeOutlineColor={darkColour}
                      spellCheck={false}
                      contentStyle={styles.searchTextInput} 
                      style={{marginTop:-1, height:30 }}
                      outlineStyle={{ borderWidth: 0, height:30, borderRightColor:'white', }}
                      onChangeText={handleSearchTextChange}
                    />
                  </View>
                </View>
                <View style={styles.deleteContainer}>
                  <View style={{marginHorizontal:10, width:80}}>
                    {prevDisabled === false &&
                      <MyButton btnText="Previous"
                        btnBorClr={darkColour}
                        btnBorRadius={10}
                        btnBorWdt={2}
                        disabled = {prevDisabled}
                        btnFontSize={15}
                        btnHeight={32}
                        btnWidth={75}
                        btnPadding={4}
                        hndClicked={handlePrevClick}
                      />
                    }
                  </View>
                  <View style={{marginHorizontal:10, width:80}}>
                    {nextDisabled === false &&
                      <MyButton btnText="Next"
                        btnBorClr={darkColour}
                        btnBorRadius={10}
                        btnBorWdt={2}
                        disabled = {nextDisabled}
                        btnFontSize={15}
                        btnHeight={32}
                        btnWidth={75}
                        btnPadding={4}
                        hndClicked={handleClick}
                      /> 
                    }
                  </View>
                
                </View>
              </View>
              <View style={styles.mainDataView}>
                <View style={styles.headerBox}>
                  <View style={{ ...styles.columnHeaderBox, marginLeft: -2 }}>
                    <Text style={{ ...styles.columnHeaderText }}>Qty</Text>
                  </View>
                  <View style={{ ...styles.columnHeaderBox, width: 200 }}>
                    <Text style={{ ...styles.columnHeaderText }}>Date and Time</Text>
                  </View>
                  <View style={{ ...styles.columnHeaderBox, width: 430 }}>
                    <Text style={{ ...styles.columnHeaderText }}>Notes</Text>
                  </View>
                  <View style={{ ...styles.columnHeaderBox, width: 120 }}>
                    <Text style={{ ...styles.columnHeaderText }}>Cost (₦)</Text>
                  </View>
                  <View style={{ ...styles.columnHeaderBox, width: 167 }}>
                    <Text style={{ ...styles.columnHeaderText }}>Total Cost (₦)</Text>
                  </View>
                </View>
                <FlatList
                  data={filteredResultStock}
                  keyExtractor={(item) => item.ID.toString()}
                  renderItem={({ item, index }) => (
                    <VendorSub
                      key={item.ID}
                      texts={[
                        item.Quantity.toString(),
                        item.Last_Updated,
                        item.Notes ? item.Notes : ' ',
                        item.Amount_Paid ? Number(item.Amount_Paid).toLocaleString('en-NG') : '0.00',
                        isNaN(item.Amount_Paid) ? '0.00' : Number(item.Amount_Paid * item.Quantity).toLocaleString('en-NG'),
                      ]}
                      index={index}
                      id={item.ID}
                      onPressed={()=>{}}
                    />
                  )}
                />
              </View>
              <View style={styles.footerMainContainer}>
                <View style={styles.footerSub}>
                  <View>
                    <View style={{height: 40, flexDirection: 'row'}}>
                      
                      <View style={styles.footerRightContainer}>
                        <Text style={{...styles.columnHeaderText, color:'white', paddingTop:3}}>
                          Gross Total
                        </Text>
                        <IconButton
                          icon="ray-start-arrow"
                          iconColor= 'white'
                          size={40}
                          focusable={false}
                          style={{marginHorizontal:20, marginTop:-8}}
                        />
                      </View>
                    </View>
                  </View>
                  <View style={styles.totalMainContainer}>
                    <View style={styles.totalContainer}>
                      <Text style= {{...styles.columnHeaderText, fontWeight:'900'}}>
                        {Number(grossTotal).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </Modal>
        </Portal>
        
      </View>
      
    </PaperProvider>
  )
}

export default VendorView

const styles=StyleSheet.create ({
  vendorContainer: {
    width:330,
    height:333,
    borderRadius:0,
    borderWidth:2,
    borderColor:'#DCE3E8',
    flexDirection:'column',
    backgroundColor:'white',
    alignContent:'center',
  },
  vendorParentContainer: {
    width:330,
    height:445,
    borderRadius:10,
    borderWidth:2,
    borderColor:'#DCE3E8',
    flexDirection:'column',
    backgroundColor:'white',
    alignItems:'center',
    justifyContent:'center',
    margin:10
  },
  vendorTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: 'transparent',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
  viewStyle: {
		borderWidth: 2,
    borderLeftWidth: 0,
		borderColor: 'black', 
		height: 35, 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
    flexDirection:'row',
    justifyContent:'center'
	},
	textStyle: {
		color: darkColour,
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 0,
    marginLeft:10
	},
  iconButtonStyle: {
    justifyContent:'center', 
    padding:0, 
    margin:0, 
    marginLeft: -5, 
    alignContent:'center',
  },
  headerText: {
    color:darkColour, 
    fontFamily:'century gothic', 
    fontSize:18, 
    fontWeight:'normal', 
    textAlign:'left',
    marginTop:5,
    margin:10, 
    },
  columnHeaderBox: {
    paddingTop:2,
    borderWidth:2, 
    borderColor:'black', 
    width:57,  
    height:'100%', 
    alignItems:'center',
    borderTopWidth:0,
    marginLeft:-2,
  },
  columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
    },
  modalContainer: {
    justifyContent: 'center',
    alignSelf:'center',
    alignItems: 'center',
    backgroundColor: 'white',
    width:1040, 
    height:500, 
    borderWidth:1, 
    borderColor:darkColour, 
    borderRadius:10, 
  },
  mainDataView: {
    flex:1, 
    height:500, 
    borderWidth:2, 
    borderBottomWidth:0,
    borderColor:'#DCE3E8', 
    marginTop:10, 
    marginBottom:0, 
    borderRadius:10,
    borderBottomLeftRadius:0,
    borderBottomRightRadius:0,
    marginLeft:20, 
    marginRight:20, 
    backgroundColor:'white'
  },
  headerBox: {
		width:'100%', 
		height:35, 
		backgroundColor: darkColour, 
		flexDirection:'row', 
		borderTopLeftRadius:10, 
		borderTopRightRadius:10
	},
  deleteContainer: {
    flexDirection:'row',
		flex:1, 
		backgroundColor:'white', 
		alignSelf:'center',
    justifyContent:'flex-end',
		paddingRight:10
	},
	footerMainContainer: {
		height:40, 
		marginLeft:20,
		marginRight:20, 
		marginBottom:10, 
		borderRadius:10, 
		borderTopRightRadius:0,
		borderTopLeftRadius:0,
		borderWidth:2, 
		borderTopWidth:0,
		borderColor:'#DCE3E8',
		backgroundColor: darkColour,
		alignItems:'center'
	},
	footerLeftContainer: {
		alignSelf:'flex-start', 
		alignItems: 'flex-start', 
		marginLeft:500, 
		height:28, 
		width:312,
    
    backgroundColor:'red'
	},
	footerSub: {
		flexDirection:'row', 
		alignSelf:'center'
	},
	footerRightContainer: {
		flexDirection:'row', 
		height:54, 
		width:630, 
		alignSelf:'flex-start', 
		justifyContent: 'flex-end',
	},
	totalContainer: {
		flexDirection:'row', 
		justifyContent:'center', 
		borderWidth:2, 
		borderLeftWidth:0, 
		borderRightWidth:0, 
		marginTop:2, 
		borderColor:'white', 
		width:152, 
		height:35, 
		alignSelf:'flex-end', 
	},
	totalMainContainer: {
		height: 40, 
		width:300, 
		alignItems:'center',
	},
  searchTextInput: {
    paddingTop: 2, 
    paddingBottom:0,
    borderWidth:2, 
    borderRightWidth:0,
    borderRightColor:'white',
    width: 350, 
    height:30, 
    borderRadius:10, 
    borderTopRightRadius:10,
    borderBottomRightRadius:10,
    borderColor: 'transparent',
  },
	headerContainer: {
		flexDirection:'column', 
		backgroundColor:'white', 
		alignSelf:'center', 
		borderWidth:2, 
		borderColor: '#DCE3E8', 
		borderRadius:10, 
		marginLeft:10, 
		marginTop:10, 
		marginBottom:10, 
		width:355, 
		height:40,
	},
  mainView: {
		flexDirection: 'row', 
		backgroundColor: 'white', 
		borderWidth: 2, 
		borderRadius: 10, 
	  marginHorizontal:20,
    marginTop:20,
		borderColor: '#DCE3E8',
	},
	textInputMasterContainer: {
		flexDirection:'row', 
		width:410, 
		height:40
	},
  boxFooterText: {
    width: '100%', 
    height: 40, 
    flexDirection: 'row', 
    backgroundColor: darkColour, 
    borderBottomRightRadius: 10, 
    borderBottomLeftRadius: 10, 
    justifyContent: 'flex-start'
  },
  boxFooterTotal: {
    width: 150, 
    borderWidth: 2, 
    borderColor: 'white', 
    marginLeft: -2, 
    borderTopWidth: 0, 
    borderBottomWidth: 0, 
    justifyContent: 'center'
  },
  secondBox: {
    width: 960, 
    height:368,
    backgroundColor:'white', 
    borderRadius:10, 
    borderWidth:2, 
    borderBottomWidth:2, 
    borderLeftWidth:2, 
    borderColor:'#DCE3E8',
    margin:10,
    alignContent:'center'
  },
  secondBoxHeader: {
		width: 1040,
		height: 35,
    marginHorizontal: 10,
		backgroundColor: darkColour,
		flexDirection: 'row',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
  tabHeadText: {
    fontFamily:'century gothic', 
    fontSize:17, 
    fontWeight:'bold', 
    textAlign:'center',
    color: darkColour, 
    marginTop:0
  },
  childTouchable: {
		flexDirection: 'row',
		alignItems: 'center',
		height: 35,
		borderColor: 'black',
		borderTopWidth: 2,
		borderBottomWidth: 2,
		marginTop: -2,
	},
	childBoxes: {
		borderWidth: 2, 
		borderColor: 'black', 
		height: '100%', 
		alignItems: 'center', 
		marginLeft: -2, 
		borderTopWidth: 0, 
		borderBottomWidth: 0,
	},
	childText: {
		fontFamily: 'century gothic', 
		fontSize: 15, 
		fontWeight: 'normal',
		marginTop: 6,
	}
})